import { API } from "../../../core/config";
import client from "../../../core/http/client";

import { ApiResponse } from "../../../shared/types/api";

import {
    LoginData,
    LoginPayload,
    MeApiResponse,
    RefreshData,
    RegisterData,
    RegisterPayload,
    StatusData,
} from "../types";

/**
 * Config custom pour bypass le refresh auto (sur login/register).
 */
const SKIP_REFRESH_CONFIG = {
    _skipAuthRefresh: true,
} as const;

class AuthApi {
    async status(): Promise<ApiResponse<StatusData>> {
        const response = await client.get<ApiResponse<StatusData>>(
            API.AUTH.STATUS,
        );
        return response.data;
    }

    async register(
        payload: RegisterPayload,
    ): Promise<ApiResponse<RegisterData>> {
        const response = await client.post<ApiResponse<RegisterData>>(
            API.AUTH.REGISTER,
            payload,
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }

    async login(
        payload: LoginPayload,
    ): Promise<ApiResponse<LoginData>> {
        const response = await client.post<ApiResponse<LoginData>>(
            API.AUTH.LOGIN,
            payload,
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }

    async refresh(): Promise<ApiResponse<RefreshData>> {
        const response = await client.post<ApiResponse<RefreshData>>(
            API.AUTH.REFRESH,
            undefined,
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }

    async me(): Promise<ApiResponse<MeApiResponse["data"]>> {
        const response = await client.get<ApiResponse<MeApiResponse["data"]>>(
            API.AUTH.ME,
        );
        return response.data;
    }

    async logout(): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            API.AUTH.LOGOUT,
            undefined,
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }

    async forgotPassword(email: string): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            API.AUTH.FORGOT_PASSWORD,
            { email },
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }

    async verifyResetCode(
        email: string,
        code: string,
    ): Promise<ApiResponse<{ tokenId: string }>> {
        const response = await client.post<ApiResponse<{ tokenId: string }>>(
            API.AUTH.VERIFY_RESET_CODE,
            { email, code },
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }

    async resetPassword(
        tokenId: string,
        newPassword: string,
    ): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            API.AUTH.RESET_PASSWORD,
            { tokenId, newPassword },
            SKIP_REFRESH_CONFIG,
        );
        return response.data;
    }
}

export const authApi = new AuthApi();

export default authApi;